(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('vip') !== 'invited') return;

  // Add a client-side robots directive for this private view.
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = document.createElement('meta');
    robots.setAttribute('name', 'robots');
    document.head.appendChild(robots);
  }
  robots.setAttribute('content', 'noindex, nofollow, noarchive');

  document.documentElement.classList.add('vip-invited');

  const priceNodes = document.querySelectorAll('[data-vip-price]');
  if (!priceNodes.length) return;

  const formatMoney = (cents, currency) => {
    // Prefer Shopify's formatter when available so the store's format is respected.
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'THB',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toLocaleString()} ${currency || 'THB'}`;
    }
  };

  priceNodes.forEach(async (node) => {
    const handle = node.dataset.productHandle;
    const currency = node.dataset.currency || 'THB';
    if (!handle) return;

    try {
      // Native Shopify endpoint. Called only in VIP view.
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const product = await res.json();
      const requestedVariantId = new URLSearchParams(window.location.search).get('variant');

      let variant = null;
      if (requestedVariantId && Array.isArray(product.variants)) {
        variant = product.variants.find(v => String(v.id) === String(requestedVariantId));
      }
      if (!variant && Array.isArray(product.variants)) {
        variant = product.variants.find(v => v.available) || product.variants[0];
      }

      if (!variant || variant.available === false) {
        return;
      }

      const publicText = node.parentElement?.querySelector('.js-public-price-on-request')
        || document.querySelector('.js-public-price-on-request');

      if (publicText) publicText.hidden = true;

      node.textContent = formatMoney(variant.price, currency);
      node.hidden = false;
    } catch (err) {
      // If VIP price cannot load, leave the normal Price on request text visible.
      console.warn('VIP price could not be loaded.', err);
    }
  });
})();
